import React from "react";

const HelloWorld = ({ name = "World" }) => {
  return React.createElement(
    "div",
    { className: "p-4 border border-blue-200 rounded-lg bg-blue-50" },
    React.createElement(
      "h2",
      { className: "text-xl font-semibold text-blue-800" },
      `Hello, ${name}!`
    ),
    React.createElement(
      "p",
      { className: "mt-2 text-blue-600" },
      "🚀 This React component is now powered by Vite instead of Shakapacker! HMR is working! 🎉"
    )
  );
};

export default HelloWorld;
